window.ValetStep4 = {

    fieldMap: {

        "full-name": "fullName",

        "phone-number": "phone",

        "address-line-1": "line1",

        "address-line-2": "line2",

        "postal-code": "postcode",

        "unit-number": "unit",

        "elevator-access": "elevator"

    },

    init() {

        this.form = document.querySelector(
            ".valet-step-4__form"
        );

        if (!this.form) return;

        this.fields =
            this.form.querySelectorAll(
                "[data-address-field]"
            );

        this.restore();

        this.bind();

        this.updateSummary();

        // Don't validate immediately
        const next =
            document.querySelector(
                "[data-booking-next]"
            );

        if (next) {

            next.disabled = false;

        }

    },

    bind() {

        this.fields.forEach(field => {

            field.addEventListener(
                "input",
                () => {

                    this.save();

                }
            );

            field.addEventListener(
                "change",
                () => {

                    this.save();

                }
            );

        });

    },

    save() {

        const booking =
            window.valetBooking;

        this.fields.forEach(field => {

            const key =
                this.fieldMap[
                    field.dataset.addressField
                ];

            if (!key) return;

            booking.address[key] =
                field.value.trim();

        });

        this.updateSummary();

        this.validate();

    },

    restore() {

        const booking =
            window.valetBooking;

        this.fields.forEach(field => {

            const key =
                this.fieldMap[
                    field.dataset.addressField
                ];

            if (!key) return;

            field.value =
                booking.address[key] || "";

        });

    },

    updateSummary() {

        const a =
            window.valetBooking.address;

        const lines = [];

        if (a.fullName)
            lines.push(a.fullName);

        if (a.line1)
            lines.push(a.line1);

        if (a.line2)
            lines.push(a.line2);

        if (a.unit)
            lines.push(a.unit);

        if (a.postcode)
            lines.push(
                "Singapore " + a.postcode
            );

        document
            .querySelectorAll(
                '[data-summary="delivery-address"]'
            )
            .forEach(item => {

                item.innerHTML =
                    lines.length
                        ? lines.join("<br>")
                        : "—";

            });

    },

    validate() {

        const a =
            window.valetBooking.address;

        this.fields.forEach(field => {

            const key =
                field.dataset.addressField;

            const optional =

                key === "address-line-2" ||

                key === "unit-number";

            if (optional) {

                field.classList.remove(
                    "is-invalid"
                );

                return;

            }

            field.classList.toggle(

                "is-invalid",

                !(field.value || "").trim()

            );

        });

        const valid =

            a.fullName &&
            a.phone &&
            a.line1 &&
            a.postcode &&
            a.elevator;

        const next =
            document.querySelector(
                "[data-booking-next]"
            );

        if (next) {

            next.disabled = !valid;

        }

        return !!valid;

    }

};